import { HarvestingTime } from '@gtpl/shared-models/raw-material-procurement';
import { VehicleInfoReq } from './vehicle-info-req';

export class VehicleAssignmentDTO{
    
    assignedDate : Date;
    // driverId: number;
    // vehicleNo : string;
    harvestingDate : Date;
    harvestingTime : HarvestingTime;
    indentId : number;
  vechileInfo:VehicleInfoReq[]
    createdUser?:string;
    updatedUser?:string;
    // driverName?:string
    /**
     * 
     * @param vehicleAssignId 
     * @param assignedDate 
     * @param driverId 
     * @param vehicleId 
     * @param harvestingDate 
     * @param harvestingTime 
     */
    constructor(
        // vehicleAssignId : number,
        assignedDate : Date,
        // driverId: number,
        // vehicleNo : string,
        harvestingDate : Date,
        harvestingTime : HarvestingTime,indentId:number,
  vechileInfo:VehicleInfoReq[],
  createdUser?:string,
        updatedUser?:string,
        // driverName?:string
    ){
        // this.vehicleAssignId = vehicleAssignId;
        this.assignedDate = assignedDate;
        // this.driverId= driverId;
        // this.vehicleNo= vehicleNo;
        this.harvestingDate= harvestingDate;
        this.harvestingTime= harvestingTime;
        this.indentId= indentId;
        this.createdUser= createdUser;
        this.updatedUser= updatedUser;
        // this.driverName = driverName
        this.vechileInfo = vechileInfo
    }
}
